import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { asyncLoginPass, logout } from "reducers/Login"

const useLogin = ( ) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginState = useSelector(state => state.login);

    // 로그인 여부
    const isLogin = !!loginState.id;

    // 로그인
    const doLogin = async (loginParam) => { 
        const action = await dispatch(asyncLoginPass(loginParam));
        return action.payload;
    }
    
    // 로그아웃
    const doLogout = () => {
        dispatch(logout());
    }

    // 파라미터 경로로 이동
    const moveToPath = (path) => {
        navigate({pathname: path}, {replace:true});
    }

    // 로그인 페이지로 이동
    const moveToLogin = () => {
        navigate({pathname: '/'}, {replace:true});
    }
    
    // 시스템 페이지 접근 검사
    const checkSystem = () => { 
        if (!loginState.authTypes.includes("SYSTEM")){
            alert("허용되지 않은 접근입니다.");
            navigate(-1);
        }
    }

    return { loginState, isLogin, doLogin, doLogout, moveToPath, moveToLogin, checkSystem };
}
export default useLogin;